import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const TEAM_ROLES = new Set([
  "super_admin", "admin", "management", "finance",
  "sales", "procurement", "qc", "operations", "partner",
]);

function landingFor(role) {
  if (TEAM_ROLES.has(role)) return "/portal/home";
  if (role === "supplier" || role === "vendor") return "/portal/vendor";
  return "/portal/client";
}

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/auth/google/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          throw new Error(body.detail || "Google sign-in failed");
        }
        const user = await res.json();
        if (user?.token) localStorage.setItem("fs_token", user.token);
        setUser(user);
        // Clear hash so a refresh doesn't retry
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${user.name}`);
        nav(landingFor(user.role), { replace: true, state: { user } });
      } catch (err) {
        toast.error(err.message || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-[80vh] flex items-center justify-center bg-[#12283F] text-white"
    >
      <div className="text-center">
        <div className="eyebrow text-[#B8965A] mb-3">Signing you in</div>
        <div className="font-serif text-3xl">One moment…</div>
      </div>
    </div>
  );
}
